const echartConf = {
  multipleColor: ['#5682DC', '#6435E8'], //饼图
  lineColor: ['#6435E8', '#5682DC'], //折线图
  tooltip: {
    trigger: 'axis',
    axisPointer: {type:'shadow'}
  }
};
export default echartConf;